<div *ngIf="filteredEmployees$ | async as filteredEmployees">
    <mat-form-field appearance="outline">
        <mat-label>Employee</mat-label>
        <input
            matInput
            [formControl]="employeeControl"
            [matAutocomplete]="autoEmployees"
            (ngModelChange)="employeeFilter$.next($event)" />
        <button *ngIf="isEmployeeSelected()" matSuffix mat-icon-button aria-label="Clear" (click)="clearEmployee()">
            <mat-icon>close</mat-icon>
        </button>
        <mat-hint>Filters timesheets and timecards.</mat-hint>
    </mat-form-field>
    <mat-autocomplete #autoEmployees="matAutocomplete">
        <mat-option *ngFor="let employee of filteredEmployees; trackBy: trackBy" [value]="employee.fullName">
            {{ employee.fullName }}
        </mat-option>
    </mat-autocomplete>
</div>
